import { RootState } from '../../../config';

export const selectFuelTransactions = (state: RootState): any =>
  state.userData.fuelTransactions.entities;

export const selectTotalFuelTransactions = (state: RootState): any =>
  state.userData.fuelTransactions.total;

export const selectDisplayFuelTransactions = (state: RootState): any =>
  state.userData.fuelTransactions.display;

export const selectSelectedFuelTransaction = (state: RootState): any =>
  state.userData.fuelTransactions.selected;

export const selectFuelTransactionsLoading = (state: RootState): boolean =>
  state.userData.fuelTransactions.loading;

export const selectFuelTransactionLoading = (state: RootState): boolean =>
  state.userData.fuelTransactions.fuelTransactionLoading;

export const selectIsInitialFuelTransactionsLoad = (
  state: RootState
): boolean =>
  state.userData.fuelTransactions.loading &&
  !state.userData.fuelTransactions.entities?.length;
